import Actions from '../../odata/actions';

const actions = new Actions('driedAbaloneSummaryItem', 'driedAbaloneSummaryItems');

export default actions;
